import * as React from 'react';
export const ToastContext = /*#__PURE__*/React.createContext(undefined);
export function useToastContext() {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error('Base UI: useToast must be used within <Toast.Provider>.');
  }
  return context;
}